export default "__VITE_ASSET__DuNx8VJD__"